import { MERGE_PATCH_HEADER } from "@constants";
import { useForm } from "react-hook-form";
import { updateExpiryDateCardRoute } from "@api-routes/payments";
import { getStateToPayload } from "../mappers/updateExpiryDateCardMapper";
import { useFetch } from "@common/hook/useFetch";

export const useEditExpiryDateCard = (
    accountId: string,
    cardId: number,
    finishEdit: () => void,
    setExpiryDate: (expiryDate: string) => void
) => {
    const [editExpiryState, { patch }] = useFetch();
    const formMethods = useForm<{ expiryMonthField: string; expiryYearField: string }>({
        defaultValues: { expiryMonthField: "", expiryYearField: "" },
    });

    const editExpiryDate = formMethods.handleSubmit((formData) => {
        const payload = getStateToPayload(formData.expiryMonthField, formData.expiryYearField);

        patch<boolean>(updateExpiryDateCardRoute(cardId, accountId), {
            body: payload,
            headers: MERGE_PATCH_HEADER,
        }).then((response) => {
            if (response) {
                setExpiryDate(payload.expirationDate);
                finishEdit();
            }
        });
    });

    return { formMethods, editExpiryDate, editExpiryState };
};
